/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Room_Warn_Change_But_Have_ModificationsInputs */



/**
* | output |
* | --- |
* | "Please save or cancel your changes to the current room to continue" |
*
* @param {Add_Room_Warn_Change_But_Have_ModificationsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const add_room_warn_change_but_have_modifications = /** @type {((inputs?: Add_Room_Warn_Change_But_Have_ModificationsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Room_Warn_Change_But_Have_ModificationsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Please save or cancel your changes to the current room to continue")
	return /** @type {LocalizedString} */ ("Veuillez enregistrer ou annuler vos modifications de la pièce actuelle pour poursuivre")
});